import { MMKV } from 'react-native-mmkv';
import { Platform } from 'react-native';

const CHECKLIST_MARK_TIP_STORAGE_KEY_PREFIX = 'onboarding:checklist_mark_tap_tip_dismissed';
const dismissedInCurrentSession = new Set<string>();
let checklistMarkTipStorage: MMKV | null = null;

export const buildChecklistMarkTipMessage = (mediaObservationsEnabled: boolean): string =>
  `Toque uma vez em cada ponto da imagem para adicionar círculos. Não arraste o dedo.${
    mediaObservationsEnabled ? ' Se precisar, adicione uma observação.' : ''
  }`;

const getChecklistMarkTipStorage = (): MMKV | null => {
  if (Platform.OS === 'web') return null;
  if (!checklistMarkTipStorage) checklistMarkTipStorage = new MMKV({ id: 'onboarding-checklist-share' });
  return checklistMarkTipStorage;
};

export const buildChecklistMarkTipStorageKey = (userId?: string | null): string =>
  `${CHECKLIST_MARK_TIP_STORAGE_KEY_PREFIX}:${userId || 'anonymous'}`;

export const readChecklistMarkTipDismissed = (storageKey: string): boolean => {
  if (dismissedInCurrentSession.has(storageKey)) return true;
  if (Platform.OS === 'web') {
    try {
      if (typeof window === 'undefined' || !window.localStorage) return false;
      return window.localStorage.getItem(storageKey) === '1';
    } catch { return false; }
  }
  try { return getChecklistMarkTipStorage()?.getString(storageKey) === '1'; } catch { return false; }
};

export const persistChecklistMarkTipDismissed = (storageKey: string): void => {
  dismissedInCurrentSession.add(storageKey);
  if (Platform.OS === 'web') {
    try {
      if (typeof window === 'undefined' || !window.localStorage) return;
      window.localStorage.setItem(storageKey, '1');
    } catch { /* storage pode estar indisponível em modo privado */ }
    return;
  }
  try { getChecklistMarkTipStorage()?.set(storageKey, '1'); } catch { /* Mantém o fluxo disponível sem storage local */ }
};
